import styled from 'styled-components';
import { Option, Select, Text } from '@alefeducation/ui-elements-library-core';
import { useAvatarUploadContext } from './context';
import { getStatus } from './AvatarRow';
import { AvatarStatus } from '../../pages/AvatarUpload/types';
import { CHARACTERS, NATURE, OTHERS } from '../../utils/constants';
import useAllOrganisationsAPI from '../RolesAndPermissions/CreateNewRole/hooks/useAllOrganisationsAPI';
import { genders } from '../../utils/gender';
import { useGetAllTenants } from '../../apollo/queries/getAllTenants.queries';

type DropdownOption = {
  value: string;
  id: string;
};

type DropdownData = {
  [key: string]: DropdownOption[];
};

export const FilterRow = () => {
  const { filters, onFilterChange } = useAvatarUploadContext();
  const { organisations } = useAllOrganisationsAPI();
  const { tenants } = useGetAllTenants();

  const appendAllOption = (data: any[]) => [{ value: 'All' }, ...data];

  const dropdownData: DropdownData = {
    tenant: [...tenants].map((c) => ({ value: c, id: c })),
    organization: organisations.map((o) => ({ value: o.name, id: o.code })),
    category: [
      { value: CHARACTERS, id: CHARACTERS },
      { value: NATURE, id: NATURE },
      { value: OTHERS, id: OTHERS },
    ],
    gender: [...genders.map((g) => ({ value: g.name, id: g.name }))],
    status: [
      {
        value: getStatus(AvatarStatus.ENABLED),
        id: getStatus(AvatarStatus.ENABLED),
      },
      {
        value: getStatus(AvatarStatus.DISABLED),
        id: getStatus(AvatarStatus.DISABLED),
      },
      {
        value: getStatus(AvatarStatus.DELETED),
        id: getStatus(AvatarStatus.DELETED),
      },
    ],
  };

  const dropdowns = Object.keys(dropdownData);
  const getOrgValue = (key: string) => {
    const value = (filters as any)[key];
    if (['All', ''].includes(value)) return value;
    return organisations.find((o) => o.code === value)?.name;
  };

  return (
    <StyledContainer data-testid="filter-row">
      {dropdowns.map((key) => {
        const selectedValue: string =
          key === 'organization' ? getOrgValue(key) : (filters as any)[key];
        const options = appendAllOption(dropdownData[key]);
        return (
          <DropdownContainer key={key} data-testid={key}>
            <StyledText variant="body-large" color="text.100">
              {key}
            </StyledText>
            <StyledSelect
              key={key}
              cursor="default"
              data-testid={`select-${key}`}
              id={key}
              onSelectChange={() => {}}
              placeholder="Placeholder"
              selectedOption={selectedValue === '' ? 'All' : selectedValue}
              textDirection="ltr"
              variant="default"
            >
              {options.map((o) => (
                <Option
                  key={`${key}-${o.value}`}
                  value={o.value}
                  onClick={() => {
                    const selectedOption = o.value === 'All' ? '' : o.id;
                    onFilterChange(key, selectedOption);
                  }}
                  selected={o.value === selectedValue}
                >
                  {o.value}
                </Option>
              ))}
            </StyledSelect>
          </DropdownContainer>
        );
      })}
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  column-gap: 16px;
`;

const DropdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  column-gap: 16px;
  row-gap: 6px;
  width: 25%;
`;

const StyledSelect = styled(Select)`
  width: 100%;
`;

const StyledText = styled(Text)`
  text-transform: capitalize;
  font-weight: 300;
`;
